import { lazy } from 'react';
import { authRoles } from 'app/auth';

const PatientsHelpPage = lazy(() => import('./pages/PatientsHelpPage'));
const PatientsHelpIssueDetailsPage = lazy(() => import('./pages/PatientsHelpIssueDetailsPage'));

const PatientsConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'patients-help',
      element: <PatientsHelpPage />,
    },
    {
      path: 'patients-help/:issueId',
      element: <PatientsHelpIssueDetailsPage />,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: false,
            },
          },
        },
      },
    },
  ],
};

export default PatientsConfig;
